// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Recharge_sidebar__I7xcZ {
    background-color: #ffffff;
    width: 250px;
    margin: 0;
    padding: 0;
    text-align: start;
    font-family: 'Roboto', sans-serif;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.Recharge_customlink__xhfnn {
    color: #0069ff;
    padding: 10px;
    display: block;
    text-decoration: none;
    border-bottom: 1px solid rgb(206, 206, 206);
    transition: all 0.3s;
}

.Recharge_customlink__xhfnn:hover {
    background-color: #0069ff;
    color: white;
    border-radius: 5px;
}

.Recharge_activelink__yNtey {
    background-color: #0069ff;
    color: white;
    border-radius: 5px;
}

.Recharge_khungbank__Fy9BR {
    border: 1px solid gray;
    margin: 10%;
    width: 100%;
    height: 80%;
}

.Recharge_customlinkmenu__jtKOH {
    color: #fefefe;
    border-bottom: 1px solid rgb(206, 206, 206);
}

.Recharge_customlinkmenu__jtKOH:hover {
    background-color: #14958d;
    color: white;
}

.Recharge_active__R2TAI {
    background-color: #61deee;
    color: white;
}

.Recharge_content__w7dwZ {
    margin-top: 60px;
}

.Recharge_buttongroup__DNDOD {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.Recharge_button__LgxD9 {
    padding: 10px 20px;
    font-size: 1rem;
    border: 1px solid #007bff;
    background-color: white;
    color: #007bff;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s;
    margin-right: 5px;
}

.Recharge_button__LgxD9:hover {
    background-color: #007bff;
    color: white;
}

.Recharge_button__LgxD9.Recharge_active__R2TAI {
    background-color: #007bff;
    color: white;
}

.Recharge_logoContainer__7OvMV {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.Recharge_bankLogo__J81VS {
    width: 200px; 
    height: 60px;  
    object-fit: contain; 
    padding: 10px;  
    justify-content: center;
    flex-wrap: wrap;
    margin-left: 100px;

}
.Recharge_button__LgxD9 {
    background-color: #f0f0f0; /* Màu mặc định */
    border: 1px solid #ccc;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.Recharge_buttonActive__hSU8V {
    background-color: #007bff !important; /* Màu xanh khi được chọn */
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/css/Recharge.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,kBAAkB;;AAEtB;AACA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC,EAAE,2BAA2B;IACjE,YAAY;AAChB","sourcesContent":[".sidebar {\n    background-color: #ffffff;\n    width: 250px;\n    margin: 0;\n    padding: 0;\n    text-align: start;\n    font-family: 'Roboto', sans-serif;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.customlink {\n    color: #0069ff;\n    padding: 10px;\n    display: block;\n    text-decoration: none;\n    border-bottom: 1px solid rgb(206, 206, 206);\n    transition: all 0.3s;\n}\n\n.customlink:hover {\n    background-color: #0069ff;\n    color: white;\n    border-radius: 5px;\n}\n\n.activelink {\n    background-color: #0069ff;\n    color: white;\n    border-radius: 5px;\n}\n\n.khungbank {\n    border: 1px solid gray;\n    margin: 10%;\n    width: 100%;\n    height: 80%;\n}\n\n.customlinkmenu {\n    color: #fefefe;\n    border-bottom: 1px solid rgb(206, 206, 206);\n}\n\n.customlinkmenu:hover {\n    background-color: #14958d;\n    color: white;\n}\n\n.active {\n    background-color: #61deee;\n    color: white;\n}\n\n.content {\n    margin-top: 60px;\n}\n\n.buttongroup {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.button {\n    padding: 10px 20px;\n    font-size: 1rem;\n    border: 1px solid #007bff;\n    background-color: white;\n    color: #007bff;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s;\n    margin-right: 5px;\n}\n\n.button:hover {\n    background-color: #007bff;\n    color: white;\n}\n\n.button.active {\n    background-color: #007bff;\n    color: white;\n}\n\n.logoContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.bankLogo {\n    width: 200px; \n    height: 60px;  \n    object-fit: contain; \n    padding: 10px;  \n    justify-content: center;\n    flex-wrap: wrap;\n    margin-left: 100px;\n\n}\n.button {\n    background-color: #f0f0f0; /* Màu mặc định */\n    border: 1px solid #ccc;\n    padding: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.buttonActive {\n    background-color: #007bff !important; /* Màu xanh khi được chọn */\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Recharge_sidebar__I7xcZ`,
	"customlink": `Recharge_customlink__xhfnn`,
	"activelink": `Recharge_activelink__yNtey`,
	"khungbank": `Recharge_khungbank__Fy9BR`,
	"customlinkmenu": `Recharge_customlinkmenu__jtKOH`,
	"active": `Recharge_active__R2TAI`,
	"content": `Recharge_content__w7dwZ`,
	"buttongroup": `Recharge_buttongroup__DNDOD`,
	"button": `Recharge_button__LgxD9`,
	"logoContainer": `Recharge_logoContainer__7OvMV`,
	"bankLogo": `Recharge_bankLogo__J81VS`,
	"buttonActive": `Recharge_buttonActive__hSU8V`
};
export default ___CSS_LOADER_EXPORT___;
